import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import CheckboxComponent from '../../components/CheckboxComponent';
import InputComponent from '../../components/InputComponent';
import ClientInfo from '../subsections/ClientInfo';
import { useAuth } from '../../contexts/AuthContext';

// SCSS
import '../../assets/scss/sectionOne.scss';

const SectionOne = ({
	control,
	register,
	handleChange,
	formData,
	setValue,
	preselectedLocation,
}) => {
	const { user } = useAuth();
	const { getValues } = useFormContext();
	const [, setDepartment] = useState('');

	useEffect(() => {
		const dept = preselectedLocation || user?.department;
		if (!dept) {
			return;
		}
		setDepartment(dept);
		// Ikke overskriv lokasjon fra utkast / annen kilde
		if (!getValues('selectedLocation')) {
			setValue('selectedLocation', dept);
		}
	}, [user, preselectedLocation, setValue, getValues]);

	return (
		<div className='sectionOne flex-col gap-40'>
			<ClientInfo control={control} register={register} />

			<div className='sok flex-row'>
				<CheckboxComponent
					label={
						<span>
							Search <b>ADA</b>
						</span>
					}
					name='searchCheck'
					value='Søk'
					className='searchCheck'
					subContext='Search igangsettes av ADA parallelt med kampanjen'
					register={register}
				/>
			</div>

			<div className='flex-row stillBtn'>
				<div className='posTitle'>
					<InputComponent
						label='Stillingstittel (i annonsen)'
						type='text'
						name='stillingstittel'
						required
						register={register}
						onChange={(e) =>
							handleChange(e.target.name, e.target.value)
						}
					/>
				</div>
			</div>
		</div>
	);
};

export default SectionOne;
